import { useEffect, useState } from "react";
import { listJobs, type JobRow } from "../api";

export function Jobs() {
  const [jobs, setJobs] = useState<JobRow[] | null>(null);
  const [tenant, setTenant] = useState("");
  const [status, setStatus] = useState("");
  const [kind, setKind] = useState("");
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => { void reload(); }, [tenant, status, kind]);
  async function reload() {
    setErr(null);
    try {
      const r = await listJobs({ tenant_id: tenant, status, kind });
      setJobs(r.jobs);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "load failed");
    }
  }

  return (
    <>
      <div className="row spaced">
        <h2>Archive jobs</h2>
        <div className="row">
          <input className="input" placeholder="Tenant ID" value={tenant} onChange={e => setTenant(e.target.value)} style={{ width: 220 }} />
          <select className="select" value={kind} onChange={e => setKind(e.target.value)}>
            <option value="">All kinds</option>
            <option value="scan">scan</option>
            <option value="archive">archive</option>
            <option value="tier">tier</option>
          </select>
          <select className="select" value={status} onChange={e => setStatus(e.target.value)}>
            <option value="">All status</option>
            <option value="running">running</option>
            <option value="completed">completed</option>
            <option value="failed">failed</option>
          </select>
        </div>
      </div>
      {err && <div className="err">{err}</div>}
      {!jobs ? <div>Loading…</div> : (
        <table>
          <thead>
            <tr>
              <th>#</th><th>Tenant</th><th>Kind</th><th>Trigger</th><th>Status</th>
              <th>Started</th><th>Finished</th>
              <th>Scanned</th><th>Queued</th><th>Archived</th><th>Bytes</th><th>Errors</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(j => (
              <tr key={j.id}>
                <td>{j.id}</td>
                <td className="mono">{j.tenant_id.slice(0, 8)}…</td>
                <td>{j.kind}</td>
                <td>{j.trigger}</td>
                <td>
                  <span className={"badge " + statusClass(j.status)}>{j.status}</span>
                  {j.error_message && <div className="muted mono" title={j.error_message}>{j.error_message.slice(0, 40)}…</div>}
                </td>
                <td className="mono">{shortTs(j.started_at)}</td>
                <td className="mono">{j.finished_at ? shortTs(j.finished_at) : "—"}</td>
                <td>{j.files_scanned}</td>
                <td>{j.files_queued}</td>
                <td>{j.files_archived}</td>
                <td>{fmtBytes(j.bytes_archived)}</td>
                <td>{j.errors}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}

function statusClass(s: string): string {
  if (s === "completed") return "green";
  if (s === "running") return "amber";
  if (s === "failed") return "red";
  return "grey";
}
function shortTs(s: string): string { return s.replace("T", " ").replace("Z", "").slice(0, 19); }
function fmtBytes(n: number): string {
  if (!n) return "—";
  const units = ["B", "KB", "MB", "GB", "TB"]; let i = 0; let v = n;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return v.toFixed(v >= 100 ? 0 : 1) + " " + units[i];
}
